<template>
  <svg width="23" height="17" viewBox="0 0 23 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M8.57367 15.8992C8.23627 15.8992 7.92699 15.7862 7.67394 15.5321L2.07879 9.9119C1.5727 9.40354 1.5727 8.61276 2.07879 8.1044C2.58488 7.59605 3.37215 7.59605 3.87824 8.1044L8.60178 12.8208L19.8202 1.58049C20.3263 1.07213 21.1136 1.07213 21.6196 1.58049C22.1257 2.08884 22.1257 2.87963 21.6196 3.38798L9.50151 15.5321C9.22034 15.7862 8.91106 15.8992 8.57367 15.8992Z"
      fill="#1EEAAD"
      stroke="#1EEAAD"
      stroke-width="2" />
  </svg>
</template>
